export enum SpecialEvent {
    event = 'event',
    none = '',
    playoffs = 'playoffs',
    preseason = 'preseason',
}
